import { render, staticRenderFns } from "./mobfooter.vue?vue&type=template&id=8dba97e8"
import script from "./mobfooter.vue?vue&type=script&lang=js"
export * from "./mobfooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports